var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-carousel',{attrs:{"show-arrows":"","cycle":"","hide-delimiters":""}},_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i,staticClass:"grey lighten-4",attrs:{"src":item.src,"contain":""}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }